export default class ObjectHelper {
	static isNull (value) {
		return typeof value === 'undefined' || value === null;
	}

	static isEmpty (obj) {
		for (const prop in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, prop)) {
				return false;
			}
		}
		return true;
	}

	static isNullOrEmpty (value) {
		return typeof value === 'undefined' || value === null || value === '';
	}

	static nullToDefault (value, defaultValue = '') {
		return ObjectHelper.isNullOrEmpty(value) ? defaultValue : value;
	}

	static isNullOrlengthZore (value) {
		return ObjectHelper.isNullOrEmpty(value) || value.length === 0;
	}
	static trimToEmpty (value) {
		let Temp = '';
		Temp = value;
		return Temp.trim();
	}
}
